<template>
    <div class="row">
        <div class="col-12 my-2">
            <div class="h5" v-text="getSettingTitle()"></div>
        </div>

        <div class="col-12 my-2">
            <div class="custom-control custom-switch">
                <input
                    type="checkbox"
                    class="custom-control-input"
                    :id="bank_id+'-setting_status'"
                    name="setting_status"
                    v-model="switching_settings[bank_id].status"
                >
                <label class="custom-control-label" :for="bank_id+'-setting_status'">{{ $t('btn.is_active') }}</label>
            </div>
        </div>

        <div v-if="!loading && switching_settings[bank_id].list">
            <div v-for="(item, index) in switching_settings[bank_id].list" :key="index">
                <div class="row border border-success m-2 px-2 pb-4">
                    <div class="col-12">
                        <div class="text-danger ml-auto"
                             style="cursor: pointer; width: fit-content;"
                             @click="deleteRow(index)"
                        >
                            <i class="fas fa-trash"></i>
                        </div>
                    </div>

                    <div class="col-12">
                        <label :for="bank_id + '-' + index + '-account'" v-text="$t('label.account.number') + ' #' + (index + 1)"></label>
                        <select :id="bank_id + '-' + index + '-account'"
                                name="new_shareholder"
                                v-model="switching_settings[bank_id].list[index]"
                                class="form-control"
                        >
                            <option :value="null" selected disabled v-text="'new'"></option>
                            <option v-for="(account, index) in accounts"
                                    :key="index"
                                    :value="account.account_number"
                                    v-text="getNameForAccount(account)"
                            ></option>
                        </select>
                    </div>
                </div>
            </div>
        </div>


        <div class="col-12 mt-5 pt-5">
            <div class="d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center justify-content-between">
                    <button class="btn btn-primary mx-2"
                            type="button"
                            v-text="$t('label.add_new_record')"
                            @click="addRow()"
                    >
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {bankIdStr} from "@/constants/bankId";
import {mapGetters} from "vuex";
import {companiesStr} from "@/constants/companies";

export default {
    computed: {
        ...mapGetters('wallet', ['switching_settings', 'loading'])
    },
    data() {
        return {
        };
    },
    methods: {
        getSettingTitle() {
            return this.$t('label.bank') + ' ' + bankIdStr.get(this.bank_id);
        },
        deleteRow(index) {
            this.switching_settings[this.bank_id].list.splice(index, 1);
        },
        addRow() {
            if (this.switching_settings[this.bank_id].list.length > 100) {
                return;
            }
            this.switching_settings[this.bank_id].list.push(null);
        },
        getNameForAccount(account) {
            const company = companiesStr.get(account.company_id);
            return `${account.account_number} (${company}) `
        }
    },
    mounted() {

    },
    async beforeMount() {
        if (!this.switching_settings[this.bank_id]) {
            await this.$store.dispatch('wallet/addNewBankSwitchingSetting', this.bank_id)
        }
    },
    props: {
        bank_id: {
            required: true
        },
        accounts: {
            required: true
        }
    }
}
</script>
